import React from "react";
import Typography from "@mui/material/Typography";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styles from "./HelperText.module.scss";

const HelperText = ({ text }) => {
	return (
		<Typography variant="body1" component="span" className={styles.helperText}>
			<HelpOutlineIcon /> {text}
		</Typography>
	);
};

export default HelperText;
